import React, {PureComponent} from "react"

import {StatementItem, Wallet} from "@irati/types"
import withBranding, {WithBranding} from "@irati/brand/withBranding"
import id from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import StatusType from "@irati/wallet/types/enums/Status"
import authentication from "@irati/auth"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"

import PrimaryDetails from "../PrimaryDetails"
import {StyledProfilePicture, StyledCard} from "../styled"

interface Props extends InjectIntl, WithBranding {
  statementItem: StatementItem
  wallet: Wallet
  className?: string
  isTenantWallet: boolean
}

class RefundFromRewardsWallet extends PureComponent<Props> {
  getTenantWalletDetails = (details) => {
    const {formatMessage, statementItem} = this.props
    const {sender} = statementItem.transfer.refundToTenantWallet
    return {
      ...details,
      status: StatusType.CLEARED,
      ProfilePicture: <StyledProfilePicture user={sender} regular />,
      title: `${sender.firstname} ${sender.lastname}`,
      subTitle: formatMessage({id: "wallet.reward.refundFromRewards.tenantSubtitle"})
    }
  }

  render() {
    const {statementItem, formatMessage, isTenantWallet, branding} = this.props
    const tenant = authentication.userTenant()
    const {transfer} = statementItem
    const {amount, currency} = transfer

    const primaryDetails = {
      image: branding.businessLogoUrl || perkboxLogo,
      title: tenant.public_name,
      subTitle: formatMessage({id: "wallet.reward.refundFromRewards.subtitle"}),
      amount,
      currency,
      status: StatusType.SPENT
    }
    const idNamespace = id("transfer-to-rewards-wallet", this.props)
    return (
      <StyledCard medium noBorder>
        <PrimaryDetails
          imgHeightAuto
          id={idNamespace}
          data={isTenantWallet ? this.getTenantWalletDetails(primaryDetails) : primaryDetails}
        />
      </StyledCard>
    )
  }
}

export default injectIntl(withBranding(RefundFromRewardsWallet))
